export const events = {
  lockPayrollRun: 'Lock payroll run',
  unlockPayrollRun: 'Unlock payroll run',

  createCompensation: 'Create compensation',
  updateCompensation: 'Update compensation',
  deleteCompensation: 'Delete compensation',

  changePayrollRunStatus: 'Change payroll run status',

  createPayrollConcept: 'Create payroll concept',
  updatePayrollConcept: 'Update payroll concept',
  togglePayrollConcept: 'Toggle payroll concept',

  openExportSidePanel: 'Open export side panel',
  completeExport: 'Complete export',
  changeExportFilter: 'Change export filter',

  startImportCompensations: 'Start import compensations',
  completeImportCompensations: 'Complete import compensations',
  deletePayrollResult: 'Delete payroll result',
  clickDeleteButtonOnPayrollResult: 'Click delete button on payroll result',
  applyFilters: 'Apply filters',
  errorImportCompensations: 'Error import compensations',
  applyEmployeeUpdatesFilter: 'Apply employee updates filter',
  sendToBookkeeper: 'Send to bookkeeper',
  sendToBookkeeperAttempted: 'Send to bookkeeper attempted',
  userClicksExportData: 'User clicks export data button',
  exportFile: 'Export Employee Updates file',
  goToEmployeeUpdatesEventLanding: 'Go to Employee Updates event landing',
  goToEmployeeUpdatesEventSettings: 'Go to Employee Updates event settings',
  clickManagePayrollResults: 'Click manage payroll results',
  removePayrollResults: 'Remove payroll results',
  syncToPayrollSoftware: 'Sync to payroll software',
  createManualEmployeeUpdate: 'Create manual employee update',
  applyEmployeeUpdateFilter: 'Apply filter in employee update',
  openEmployeeUpdatesExportModal: 'Open export modal',
  exportEmployeeUpdates: 'Export employee updates',
  clickSyncIntegration: 'Click sync integration',
  sendMessageInEmployeeUpdates: 'Send message in employee updates',
  checkDetailsInEmployeeUpdates: 'Check details in employee updates',
  changeStatusEmployeeUpdates: 'Change status employee updates',
}
